import { render, staticRenderFns } from "./SuperPrompt.vue?vue&type=template&id=5be8742b&scoped=true"
import script from "./SuperPrompt.vue?vue&type=script&lang=js"
export * from "./SuperPrompt.vue?vue&type=script&lang=js"
import style0 from "./SuperPrompt.vue?vue&type=style&index=0&id=5be8742b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be8742b",
  null
  
)

export default component.exports